import React from 'react';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import { clearBrowseName, findNameById, persistBrowseName, pushEvent } from '../../../utils/dataLayer';

export default class Mainform extends React.Component {

    state = {
        models: [],
        years: [],
        selectedModel: '',
        selectedYear: '',
        language: localStorage.getItem('language') || 'en',
        navigate: false
    }    
    


    handleSearchClick = (event) => {
        event.preventDefault();
        
        if (this.state.selectedModel) {
            localStorage.setItem('selectedModel', this.state.selectedModel);
            persistBrowseName('selectedModelName', findNameById(this.state.models, this.state.selectedModel));
        } else {
            localStorage.removeItem('selectedModel');
            clearBrowseName('selectedModelName');
        }
        
        if (this.state.selectedYear) {
            localStorage.setItem('selectedYear', this.state.selectedYear);
            persistBrowseName('selectedYearName', findNameById(this.state.years, this.state.selectedYear, ['year', 'name']));
        } else {
            localStorage.removeItem('selectedYear');
            clearBrowseName('selectedYearName');
        }
        
        // Always remove category when submitting from homepage
        localStorage.removeItem('category_id');
        localStorage.removeItem('showRacingOnly');
        localStorage.removeItem('show3dOnly');

        pushEvent('site_home_search_submitted', {
            model_id: this.state.selectedModel,
            model_name: findNameById(this.state.models, this.state.selectedModel),
            year_id: this.state.selectedYear,
            year_name: findNameById(this.state.years, this.state.selectedYear, ['year', 'name']),
        });
        
        this.setState({ navigate: true });
    }

    handleModelChange = (event) => {
        let model_id = event.target.value;
        const dealer_id = localStorage.getItem('dealer_id');
        this.setState({ selectedModel: model_id });
        localStorage.setItem('selectedModel', model_id);
        persistBrowseName('selectedModelName', findNameById(this.state.models, model_id));
        clearBrowseName('selectedYearName');
        
        let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
        const config = {
            headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
        };
        axios.get(
            process.env.REACT_APP_FORD_API_URL + '/api/v1/car-models/' + model_id + '?dealer_id=' + dealer_id + '&brand_id=' + process.env.REACT_APP_BRAND_ID + '&market_id=' + process.env.REACT_APP_MARKET_ID,
            config
        )
            .then(res => {
                if (!this._isMounted) return;
                const years = [...(res.data.years || [])].sort(
                    (a, b) => (parseInt(b.year || b.name, 10) || 0) - (parseInt(a.year || a.name, 10) || 0)
                );
                persistBrowseName('selectedModelName', res.data?.name);
                this.setState({ years });
            });
    };

    handleYearChange = (event) => {
        let year_id = event.target.value;
        this.setState({ selectedYear: year_id });
        localStorage.setItem('selectedYear', year_id);
        persistBrowseName('selectedYearName', findNameById(this.state.years, year_id, ['year', 'name']));
    };

    componentDidMount() {
        this._isMounted = true;
        const dealer_id = localStorage.getItem('dealer_id');
        const token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
        const config = {
            headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en' }
        };
        axios.get(
            process.env.REACT_APP_FORD_API_URL + '/api/v1/car-models/filter?brand_id=' + process.env.REACT_APP_BRAND_ID + '&dealer_id=' + dealer_id + '&market_id=' + process.env.REACT_APP_MARKET_ID,
            config
        )
            .then(res => {
                if (!this._isMounted) return;
                const language = localStorage.getItem('language') || 'en';
                const models = [...(res.data.data || [])].sort((a, b) =>
                    String(a?.name || '').localeCompare(String(b?.name || ''), language, { sensitivity: 'base' })
                );
                this.setState({ models });
            });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const { models, years, language } = this.state;
        
        if (this.state.navigate) {
            const params = {
              selectedModel: this.state.selectedModel,
              selectedYear: this.state.selectedYear
            };
            return <Navigate to="/accessory" state={params} />;
        }
        
        return (
            <div className={'container '+process.env.REACT_APP_WHICH_APP}>
                <div className="main-form">
                    <div className="row">
                        <div className="col-12 col-md-8 offset-0 offset-md-2">
                            <h4>
                                <span language="ar">ما نوع سيارتك؟</span>    
                                <span language="en">What's Your Ride?</span>
                            </h4>
                            <p>
                                <span language="ar">اختر سيارتك لاستكشاف مجموعة الملحقات لدينا</span>
                                <span language="en">Select your vehicle to explore our range of accessories.</span>
                            </p>

                            <form>
                                <div className="row">
                                    <div className="col-12 col-md-4 offset-md-1">
                                        <select className="form-select" aria-label="" id="modelsList" onChange={this.handleModelChange}>
                                            <option disabled selected>
                                                {language === 'en' && 'Model'}
                                                {language === 'ar' && 'الطراز'}
                                            </option>
                                            {models.map((model, key) => (
                                                <option value={model.id}>{model.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <select className="form-select" aria-label="" onChange={this.handleYearChange}>
                                            <option disabled selected>
                                                {language === 'en' && 'Year'}
                                                {language === 'ar' && 'السنة'}
                                                </option>
                                            {years.map((year, key) => (
                                                <option value={year.id}>{year.year}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-12 col-md-3 text-start">
                                        <button type="submit" className="btn ford-btn" disabled={years.length === 0} onClick={this.handleSearchClick}>
                                            <span language="ar">ابحث الآن</span>
                                            <span language="en">Search Now</span>
                                        </button>
                                    </div>
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
    }